import classNames from 'classnames/bind';
import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import styles from './EditorConfig.module.scss';

import actions from '@/actions';
import { PrimaryButton } from '@/components/ui/kit/Button';
import { FieldNumber } from '@/components/ui/kit/Field';
import ModalWrapper from '@/components/ui/ModalWrapper';
import { modalManager } from '@/libs/ModalContainer';
import { NotifierService as notifier } from '@/libs/Notifier';

const cx = classNames.bind(styles);

const Modal = () => {
  const dispatch = useDispatch();
  const config = useSelector((state) => state.editor.config);
  const [nextConfig, setNextConfig] = useState(config);
  const altitudeRef = useRef();
  const speedRef = useRef();

  const close = () => {
    modalManager.hide();
  };

  const handleChange = (e) => {
    setNextConfig({
      ...nextConfig,
      [e.target.name]: Number(e.target.value),
    });
  };

  // 유효성 검사
  const validAll = () => {
    if (Number(nextConfig.altitude) === 0) {
      notifier.error('Please enter the altitude.');
      altitudeRef.current.focus();
      return false;
    }
    if (Number(nextConfig.speed) === 0) {
      notifier.error('Please enter the speed.');
      speedRef.current.focus();
      return false;
    }
    return true;
  };

  const doSave = () => {
    if (!validAll()) return;

    dispatch(actions.editor.setConfig(nextConfig));
    close();
  };

  return (
    <ModalWrapper className={cx('container')}>
      <div className={cx('fields')}>
        <label>
          Default Altitude
          <div className={cx('fieldWrapper')}>
            <FieldNumber ref={altitudeRef} name="altitude" value={nextConfig.altitude} onChange={handleChange} />
            <div className={cx('unit')}>m</div>
          </div>
        </label>
        <label>
          Default Speed
          <div className={cx('fieldWrapper')}>
            <FieldNumber ref={speedRef} name="speed" value={nextConfig.speed} onChange={handleChange} />
            <div className={cx('unit')}>m/s</div>
          </div>
        </label>
      </div>
      <div className={cx('bottom')}>
        <PrimaryButton text="Cancel" onClick={close} />
        <PrimaryButton text="Save" accent onClick={doSave} />
      </div>
    </ModalWrapper>
  );
};

export default Modal;
